import axios from "axios";
const url = "https://bcmt-api.vercel.app/api/";
// const url = "http://localhost:4404/api/";

export default axios.create({
    baseURL: url,
});
